export default "__VITE_ASSET__DQYSn5km__"